export const DeleteIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* <rect width="32" height="32" fill="url(#paint0_radial_1121_8471)" /> */}
    <path
      d="M21.9063 9.25H18.8125V8.6875C18.8125 7.75586 18.0566 7 17.125 7H14.875C13.9434 7 13.1875 7.75586 13.1875 8.6875V9.25H10.0938C9.3168 9.25 8.6875 9.8793 8.6875 10.6562V12.625C8.6875 12.9344 8.94063 13.1875 9.25 13.1875H9.55586L10.041 23.3934C10.0832 24.2934 10.825 25 11.725 25H20.268C21.1715 25 21.9098 24.2934 21.952 23.3934L22.4441 13.1875H22.75C23.0594 13.1875 23.3125 12.9344 23.3125 12.625V10.6562C23.3125 9.8793 22.6832 9.25 21.9063 9.25ZM14.3125 8.6875C14.3125 8.37812 14.5656 8.125 14.875 8.125H17.125C17.4344 8.125 17.6875 8.37812 17.6875 8.6875V9.25H14.3125V8.6875ZM9.8125 10.6562C9.8125 10.5016 9.93906 10.375 10.0938 10.375H21.9063C22.0609 10.375 22.1875 10.5016 22.1875 10.6562V12.0625C22.0152 12.0625 10.5297 12.0625 9.8125 12.0625V10.6562ZM20.834 23.3406C20.8199 23.6395 20.5738 23.875 20.2715 23.875H11.7285C11.4262 23.875 11.1801 23.6395 11.166 23.3406L10.6844 13.1875H21.3156L20.834 23.3406Z"
      fill="var(--grey-50, #797E86)"
    />
    <path
      d="M16 22.75C16.3094 22.75 16.5625 22.4969 16.5625 22.1875V14.875C16.5625 14.5656 16.3094 14.3125 16 14.3125C15.6906 14.3125 15.4375 14.5656 15.4375 14.875V22.1875C15.4375 22.4969 15.6906 22.75 16 22.75Z"
      fill="var(--grey-50, #797E86)"
    />
    <path
      d="M18.8125 22.75C19.1219 22.75 19.375 22.4969 19.375 22.1875V14.875C19.375 14.5656 19.1219 14.3125 18.8125 14.3125C18.5031 14.3125 18.25 14.5656 18.25 14.875V22.1875C18.25 22.4969 18.5031 22.75 18.8125 22.75Z"
      fill="var(--grey-50, #797E86)"
    />
    <path
      d="M13.1875 22.75C13.4969 22.75 13.75 22.4969 13.75 22.1875V14.875C13.75 14.5656 13.4969 14.3125 13.1875 14.3125C12.8781 14.3125 12.625 14.5656 12.625 14.875V22.1875C12.625 22.4969 12.8781 22.75 13.1875 22.75Z"
      fill="var(--grey-50, #797E86)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1121_8471"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16 16) rotate(90) scale(16)"
      >
        <stop offset="0.812026" stopColor="#EDEBED" />
        <stop offset="1" stopColor="#EDEBED" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)